export const NOTIFICATION_REQUIRED_FIELDS = 'requiredFields'

export const NOTIFICATION_FILE_UPLOAD = 'fileUpload'

export const NOTIFICATION_FILE_UPLOADED_WITH_ERRORS = 'fileUploadedWithErrors'

export const NOTIFICATION_FILE_UPLOAD_LIMIT = 'fileUploadLimit'

export const NOTIFICATION_NO_CHANGES = 'NoChangedSave'

export const NOTIFICATION_INCORRECT_FIELD_VALUE = 'IncorrectFieldValue'
